import { render, staticRenderFns } from "./SystemRole.vue?vue&type=template&id=14b5b3ae&scoped=true"
import script from "./SystemRole.vue?vue&type=script&lang=js"
export * from "./SystemRole.vue?vue&type=script&lang=js"
import style0 from "./SystemRole.vue?vue&type=style&index=0&id=14b5b3ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b5b3ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b5b3ae')) {
      api.createRecord('14b5b3ae', component.options)
    } else {
      api.reload('14b5b3ae', component.options)
    }
    module.hot.accept("./SystemRole.vue?vue&type=template&id=14b5b3ae&scoped=true", function () {
      api.rerender('14b5b3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemRole/SystemRole.vue"
export default component.exports